import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { StartupErrorComponent } from './modules/not-found/startup-error.component';
import { SystemUnavailableComponent } from './modules/not-found/system-unavailable.component';
import { AppComponent } from './app.component';
import { MainComponent } from './modules/main/main.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from 'projects/shared/src/lib/core/core.module';
import { TasksModule } from 'projects/shared/src/lib/modules/tasks/tasks.module';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  appFeatureKey,
  appReducer,
} from 'projects/diso/src/app/store/app.reducer';

@NgModule({
  declarations: [AppComponent, MainComponent, StartupErrorComponent, SystemUnavailableComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    TasksModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forRoot({}, {}),
    EffectsModule.forRoot([]),
    StoreModule.forFeature(appFeatureKey, appReducer),
  ],
  providers: [],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
